import script from "./TransactionTaggingModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransactionTaggingModal.vue?vue&type=script&setup=true&lang=ts"

import "./TransactionTaggingModal.vue?vue&type=style&index=0&id=637dd42a&scoped=true&lang=css"
import "./TransactionTaggingModal.vue?vue&type=style&index=1&id=637dd42a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-637dd42a"]])

export default __exports__